<style>
    /*table {
        border: none !important;
        border-radius: 0 !important;
        background-color: transparent !important;
    }
        table thead {
            background-color:transparent !important;
        }*/
    .section--lighter-gray {
        background-color: #f6f6f6;
    }
</style>
<template>

    <div class="container ui" v-cloak>
        <brew-info />

        <brew-recipe v-show="showRecipe" />

        <brew-snapshot-chart />

        <div>
            <div class="ui divider"></div>
            <h4 class="ui header">
                <p class='float-right' style="font-size:.8rem;color:#888888;">{{remainingCount}} remaining</p>
                Recipe Discussion
            </h4>
            <div class="ui form" :class="{ 'error': errors.any() }" v-if="currentUser.isLoggedIn">
                <div class="field" :class="{ 'error': errors.has('comment_text') }">
                    <textarea rows="3" id="comment_text" name="comment_text" v-validate="'required|max:500'" data-vv-as="Comment" v-model="newCommentText" @keyup="countdown" :disabled="isSavingComment == 1" placeholder="Leave a comment or question"></textarea>

                </div>
                <a class="ui positive button" @click.stop="addComment">Add Comment</a>
                <span v-show="errors.has('comment_text')" class="ui error message">{{ errors.first('comment_text') }}</span>
            </div>


            <div class="ui feed">
                <div v-if="comments.length == 0">
                    No Comments
                </div>
                <div class="event" v-for="comment in comments" :accesskey="comment.created" v-else>
                    <div class="label">
                        <v-gravatar :size="35" :email="comment.createdBy.emailAddress"></v-gravatar>
                    </div>
                    <div class="content">
                        <div class="summary">
                            <div class="user">
                                {{ comment.createdBy.userName }}
                            </div>
                            <div class="date">
                                {{ comment.created | fromNow }}
                            </div>
                        </div>
                        <div class="extra text">
                            <vue-markdown :source="comment.comment"></vue-markdown>
                        </div>
                        <!--<div class="meta" v-show="comment.isCreator">
                            <a class="like">
                                <i class="like icon"></i> 4 Likes
                            </a>
                        </div>-->
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>
<script>
    import Vue from "vue";
    import axios from "axios";
    import BrewInfo from './BrewInfo.vue'
    import BrewRecipe from './BrewRecipe.vue'
    import BrewSnapshotChart from './BrewSnapshotChart.vue'
    import Gravatar from 'vue-gravatar';
    import Cookie from "js-cookie";
    import VeeValidate from 'vee-validate';
    import VueMarkdown from 'vue-markdown';
    import Toasted from 'vue-toasted';
    import Raven from 'raven-js';

    Vue.use(VeeValidate);
    Vue.use(Toasted, { duration: 3000 });

    Vue.component('v-gravatar', Gravatar);

    import utils from "../../utils/units";
    import * as common from "../../utils/common";
    import * as types from "./store/mutation-types";
    import { mapState, mapGetters } from 'vuex'

    export default {
        name: "Brew",
        components: {
            BrewInfo,
            BrewRecipe,
            BrewSnapshotChart,
            VueMarkdown
        },
        data() {
            return {
                isLoaded: false,
                brewItem: null,
                brewRecipe: null,
                //showRecipe: true,
                isSavingComment: false,
                newCommentText: "",
                remainingCount: 500
            }
        },
        created() {
            let showRecipe = Cookie.get("show-recipe") || 'true';

            this.$store.commit('SET_SHOW_RECIPE', showRecipe == 'true' ? true : false);
            this.$store.dispatch('getLatestStats');
            this.$store.dispatch('getComments');
        },
        mounted() {
            var self = this;

            if (Raven.isSetup() && self.currentUser.isLoggedIn) {
                Raven.setUserContext({
                    email: self.currentUser.email,
                    id: self.currentUser.userId
                })
            }
        },
        computed: {
            ...mapState(["currentUser", "brew", "brewId", "comments", "showRecipe"])
        },
        methods: {
            addComment,
            countdown
        }
    }

    function addComment() {
        var self = this;
        this.isSavingComment = true;

        this.$validator
            .validateAll()
            .then((result) => {
                if (result) {
                    self.$store
                        .dispatch("addComment", self.newCommentText)
                        .then(() => {
                            self.newCommentText = "";
                            self.remainingCount = 500;

                            this.$validator.reset();

                            self.isSavingComment = false;
                        });
                } else {
                    self.isSavingComment = false;
                    Vue.toasted.error("Unable to save changes.");
                }
            });
    }

    function countdown() {
        if (common.isEmpty(this.newCommentText)) {
            this.remainingCount = 500;
        } else {
            this.remainingCount = 500 - this.newCommentText.length;
        }
    }
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/sections/brew/Brew.vue